import { BaseDto } from './base.dto';

export class PrinterTypeDto extends BaseDto {
    // id: number;
    name: string;

  }
  